import type {ReactElement} from 'react';
import React from 'react';
import styles from './page-color-palette-styles-panel-content.module.scss';
import {applySmartColorPalette} from '@PosterWhiteboard/libraries/smart-color-palette.library';
import {ColorPalettePanel} from '@Components/color-palettes/color-palette-panel/color-palette-panel';
import type {ColorPaletteInfo, ColorPalettePill} from '@Libraries/color-palettes.library';
import {GA4EventName, GA4EventParamName, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {getUserPremiumLevel} from '@Libraries/user.library';
import {getGA4StyleTypeFromColorPalette} from '@Libraries/auto-branding-email-maker';
import {useAppSelector} from '@/hooks';
import {getCurrentPageAppliedPalette, updateFeatureDemo} from '@Components/poster-editor/poster-editor-reducer';
import {FeatureDemo} from '@Components/poster-editor/poster-editor.types';

const PAGE_PALETTE_APPLIED_EVENT = 'de-palette-applied';

export function PageColorPaletteStylesPanelContent(): ReactElement {
  const currentAppliedPalette = useAppSelector(getCurrentPageAppliedPalette);

  const onPaletteClicked = async (selectedColorPalette: ColorPaletteInfo): Promise<void> => {
    await applySmartColorPalette(selectedColorPalette);
    window.dispatchEvent(new CustomEvent(PAGE_PALETTE_APPLIED_EVENT));
  };

  return (
    <ColorPalettePanel
      onPillSelected={(pill: ColorPalettePill) => {
        trackPosterBuilderGA4Events(GA4EventName.EDITOR_STYLES_PILLS, {[GA4EventParamName.TERM]: pill.name});
      }}
      onSearchSubmit={(searchTerm: string) => {
        trackPosterBuilderGA4Events(GA4EventName.EDITOR_STYLES_SEARCHED, {[GA4EventParamName.SEARCH_TERM]: searchTerm});
      }}
      appliedColorPalette={currentAppliedPalette ?? null}
      className={`spacing-p-b-4 ${styles.container}`}
      allowShuffle
      showApplyingState={false}
      onColorPaletteSelect={(selectedColorPalette) => {
        const featureDemo = window.PMW.redux.store.getState().posterEditor.featureDemo;
        if (featureDemo === FeatureDemo.STYLES) {
          trackPosterBuilderGA4Events(GA4EventName.EDITOR_TRY_STYLE, {[GA4EventParamName.USER_PREMIUM_LEVEL]: String(getUserPremiumLevel())});
          window.PMW.redux.store.dispatch(updateFeatureDemo(FeatureDemo.NONE));
        }

        const currentlyAppliedPalette = currentAppliedPalette;

        if (currentlyAppliedPalette && currentlyAppliedPalette.type === selectedColorPalette.type && currentlyAppliedPalette.id === selectedColorPalette.id) {
          trackPosterBuilderGA4Events(GA4EventName.EDITOR_STYLES_PALETTE_SHUFFLED, {[GA4EventParamName.TYPE]: getGA4StyleTypeFromColorPalette(selectedColorPalette)});
        }

        trackPosterBuilderGA4Events(GA4EventName.EDITOR_STYLES_APPLIED, {[GA4EventParamName.TYPE]: getGA4StyleTypeFromColorPalette(selectedColorPalette)});

        void onPaletteClicked(selectedColorPalette);
      }}
      colorPaletteAppliedEvent={PAGE_PALETTE_APPLIED_EVENT}
    />
  );
}
